import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy account billing path now lives in the dashboard.
export const Route = createFileRoute('/account/billing')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/billing' });
  },
});
